module.exports = __webpack_public_path__ + "media/assets/images/back-arrow-1fb776dec2f641be6c725e51620a9421.svg";